var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 9.12909V3.74575C17.4167 2.55825 16.91 2.08325 15.6513 2.08325H12.4529C11.1942 2.08325 10.6875 2.55825 10.6875 3.74575V9.12909C10.6875 10.3166 11.1942 10.7916 12.4529 10.7916H15.6513C16.91 10.7916 17.4167 10.3166 17.4167 9.12909Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 16.2542V14.8292C17.4167 13.6417 16.91 13.1667 15.6513 13.1667H12.4529C11.1942 13.1667 10.6875 13.6417 10.6875 14.8292V16.2542C10.6875 17.4417 11.1942 17.9167 12.4529 17.9167H15.6513C16.91 17.9167 17.4167 17.4417 17.4167 16.2542Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31217 10.8708V16.2541C8.31217 17.4416 7.80551 17.9166 6.54676 17.9166H3.34842C2.08967 17.9166 1.58301 17.4416 1.58301 16.2541V10.8708C1.58301 9.68325 2.08967 9.20825 3.34842 9.20825H6.54676C7.80551 9.20825 8.31217 9.68325 8.31217 10.8708Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31217 3.74575V5.17075C8.31217 6.35825 7.80551 6.83325 6.54676 6.83325H3.34842C2.08967 6.83325 1.58301 6.35825 1.58301 5.17075V3.74575C1.58301 2.55825 2.08967 2.08325 3.34842 2.08325H6.54676C7.80551 2.08325 8.31217 2.55825 8.31217 3.74575Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.9047a8bc35d44ab61277b712b8b4c12c.svg";
export { ForwardRef as ReactComponent };